// ISO 4217 codes an invoice can be issued in. Euros are the home currency the exports book in.

export const HOME_CURRENCY = 'EUR'

export const currencies = ['EUR', 'CZK', 'USD', 'GBP', 'CHF', 'PLN', 'HUF']

export function formatMoney(amount: number, currency?: string): string {
    try {
        return new Intl.NumberFormat('sk-SK', {style: 'currency', currency: currency || HOME_CURRENCY}).format(amount)
    } catch {
        return `${amount.toFixed(2)} ${currency ?? ''}`.trim()
    }
}
